import dayjs from 'util/date';

const downloadImageCredit = () =>
  I18n.t('Explorer.download_image_credit', {
    formattedDate: dayjs().format('DD/MM/YYYY')
  });

export default downloadImageCredit;
